import AccessStatusSummaryChart from "./graphs/AccessStatusSummaryChart";
import InspectionStatusTrackerChart from "./graphs/InspectionStatusTrackerChart";
import MonthlyTruckDefectsChart from "./graphs/MonthlyTrackDefectsChart";

export default function Dashboard() {
   return <div className="p-8 bg-slate-50 flex flex-col gap-2 overflow-y-auto">
      <MonthlyTruckDefectsChart />
      <div className="grid grid-cols-2 gap-2">
         <AccessStatusSummaryChart />
         <InspectionStatusTrackerChart />
      </div>
   </div>
}
